"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.boxStyles = exports.Div = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var boxStyles = exports.boxStyles = (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 16px;\n  background-color: #ffffff;\n  border: 1px solid ", ";\n  border-radius: ", ";\n  \n  ", "\n  \n  ", "\n  \n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.detail.cc;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius;
}, function (_ref3) {
  var intent = _ref3.intent,
    theme = _ref3.theme;
  return intent === 'success' && (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    border-color: ", ";\n  "])), theme.success.cc);
}, function (_ref4) {
  var intent = _ref4.intent,
    theme = _ref4.theme;
  return intent === 'error' && (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    border-color: ", ";\n  "])), theme.danger);
}, function (_ref5) {
  var intent = _ref5.intent,
    isFilled = _ref5.isFilled,
    theme = _ref5.theme;
  return intent === 'error' && isFilled && (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    color: ", ";\n    background: ", ";\n    border: 2px solid ", ";\n  "])), theme.error, theme.errorFaded, theme.error);
});
var Div = exports.Div = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", ""])), boxStyles);
var Box = function Box(_ref6) {
  var intent = _ref6.intent,
    isFilled = _ref6.isFilled,
    style = _ref6.style,
    className = _ref6.className,
    children = _ref6.children;
  return /*#__PURE__*/_react["default"].createElement(Div, {
    intent: intent,
    isFilled: isFilled,
    style: style,
    className: className
  }, children);
};
Box.propTypes = {
  intent: (0, _propTypes.oneOf)(['primary', 'success', 'error']),
  isFilled: _propTypes.bool
};
var _default = exports["default"] = Box;


//////////////////
// WEBPACK FOOTER
// ./node_modules/abihome-components/build/components/Box/index.js
// module id = 347
// module chunks = 17